import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the NumberToArray pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */

@Pipe({ name: 'numberToArray' })

export class NumberToArray implements PipeTransform {
    transform(value: number): any {
        if (0 < value) {
            const items = [];

            for(let i = 0; i < value; i++) {
                items.push(i);
            }

            return items;
        }

        return [];
    }
}


// WEBPACK FOOTER //
// ./src/pipes/numberToArray/numberToArray.ts